import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { productsCsmChatEntryPoint as main } from '@jira/spa-apps__admin-pages-products-csm-chat/src/productsCsmChatEntryPoint.entrypoint.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { productsCsmChatRoute } from '@jira/router-routes__admin-pages-csm-chat-routes/src/productsCsmChatRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import type { Route } from '@atlassian/react-resource-router';

const productsCsmChatEntryPointPage = createPageEntryPoint({
	main,
});

export const productsCsmChatRouteEntry: Route = createEntry(productsCsmChatRoute, () => ({
	group: 'global-settings',

	navigation: {
		sidebarId: SidebarIdGlobalProductsSettings,
		menuId: MenuIdSettings,
	},

	// eslint-disable-next-line no-restricted-syntax
	component: ErrorPagesNotFound,

	entryPoint() {
		return fg('csm-omni-channel-live-chat-in-widget') ? productsCsmChatEntryPointPage : undefined;
	},

	resources: [...getNavigationResources(), ...getNavigationSidebarProductsSettingResource()],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
